// components/Blog/BlogList/BlogList.jsx

import React from "react";
import "./BlogList.scss";
import BlogData from "./BlogData";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const BlogList = () => {
  return (
    <div className="blog-list">
       <Helmet>
        <title>Blogs | World Adventures Tours</title>
        <meta
          name="description"
          content="Explore insightful articles, travel stories, and expert tips on trekking, tours, and expeditions across Gilgit-Baltistan and beyond."
        />
        <meta property="og:title" content="Blogs | World Adventures Tours" />
        <meta
          property="og:description"
          content="Read travel blogs and inspiring experiences from the mountains of Pakistan. Discover guides, tips, and real stories."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.worldadventurestours.com/Blogs" />
      </Helmet>
      <h1>Latest Blogs</h1>
      <div className="blog-cards">
        {BlogData.map((blog) => (
          <div className="blog-card" key={blog.id}>
            <img src={blog.thumbnail} alt={blog.title} />
            <h2>{blog.title}</h2>
            <p>{blog.description}</p>
            <Link to={blog.path} className="read-more">Read More</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
// BlogList.jsx